import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import {
    webchatPreviewModeAtom,
    WebchatPreviewChatModeOption,
    WebchatPreviewBannerMode
} from "@/atom/webchatPreviewMode";


type SettingTabType = "webchat" | "layout" | "style" | "banner";

export const useWebchatPreviewMode = () => {
    const [previewMode, setPreviewMode] = useAtom(webchatPreviewModeAtom);

    const setHomeMode = useCallback(() => {
        setPreviewMode({ mode: "home" });
    }, [setPreviewMode]);

    const setChatMode = useCallback((option?: WebchatPreviewChatModeOption) => {
        if (!option || option === "default") {
            setPreviewMode({ mode: "chat" });
        } else {
            setPreviewMode({ mode: "chat", chatModeOption: option });
        }
    }, [setPreviewMode]);

    const setBannerMode = useCallback((displayType: WebchatPreviewBannerMode) => {
        setPreviewMode({ mode: "banner", bannerMode: displayType });
    }, [setPreviewMode]);

    const onChangeActiveTab = useCallback((tabType: SettingTabType) => {
        if (tabType === "banner") {
            setPreviewMode({ mode: "banner", bannerMode: "desktop" });
        } else {
            setPreviewMode({ mode: "chat" });
        }
    }, [setPreviewMode]);

    return useMemo(() => {
        return {
            previewMode,
            setPreviewMode,
            onChangeActiveTab,
            setHomeMode,
            setChatMode,
            setBannerMode
        };
    }, [previewMode, setPreviewMode, onChangeActiveTab, setHomeMode, setChatMode, setBannerMode]);
};
